import type { SVGProps } from "react";
import { memo } from "react";

import { cn } from "@btnet/utilities-core";

import "./Icon.less";
import type { IIconProps } from "./Icon.types";

const SvgIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 32 32"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M6.19 3.486A2 2 0 0 0 4.255 2H2l-.117.007A1 1 0 0 0 1 3l.007.117A1 1 0 0 0 2 4h2.256l3.431 18.873A3.5 3.5 0 1 0 13.163 24h6.674A3.5 3.5 0 1 0 23 22H9.562l-.545-3h14.496l.18-.005a3 3 0 0 0 2.771-2.458l1.52-8.358.014-.115A1 1 0 0 0 27 7H6.835l-.61-3.358zM8.5 25.5a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0M23 24a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3m.513-7H8.653L7.198 9h18.604l-1.305 7.179-.029.116a1 1 0 0 1-.955.705"
      clipRule="evenodd"
    />
  </svg>
);
const SvgIconCart = ({
  testid,
  size = "md",
  className,
  ariaLabel,
  innerRef,
  ...props
}: IIconProps) => {
  const ariaVisibilityProp = ariaLabel
    ? {
        "aria-label": ariaLabel,
      }
    : {
        "aria-hidden": true,
      };
  return (
    <div
      data-testid={testid}
      className={cn("icon bds-icon", className, {
        ["bds-icon-" + size]: size,
        ["icon-" + size]: size,
      })}
      ref={innerRef}
      {...props}
    >
      <SvgIcon role="img" fill="none" {...ariaVisibilityProp} />
    </div>
  );
};
const Memo = memo(SvgIconCart);
export default Memo;
